// import { Filter } from '@/interfaces/filter.interface'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { WhitelistOneShotServices } from '../../services/modules/whitelist-one-shot.service'
import { Filter } from '@/interfaces/filter.interface'

@Module
export default class WhitelistOneShotStore extends VuexModule {
    whitelistOneShot: object[] = []
    whitelistOneShotPaginate: object[] = []
    @Mutation
    updateWhitelistOneShot (newWhitelistOneShot: object[]) {
        this.whitelistOneShot = newWhitelistOneShot
    }

    @Mutation
    updateWhitelistOneShotPaginate (newWhitelistOneShot: object[]) {
        this.whitelistOneShotPaginate = newWhitelistOneShot
    }

    @Action
    importCsvWhitelistOneShot (params: {uploadfile: File}) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve()
                return
            }
            const data = Object.assign({}, params)

            WhitelistOneShotServices.importWhitelistOneShot(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    removeCsvWhitelistOneShot (params: {uploadfile: File}) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve()
                return
            }
            const data = Object.assign({}, params)
            WhitelistOneShotServices.removeWhitelistOneShot(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getWhitelistOneShotPaginate (params: { page: number; filters?: Filter[]; limit: number; msisdn?: string; sortBy?: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                msisdn: params.msisdn,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []
                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }
            WhitelistOneShotServices.getWhitelistOneShotPaginate(newParams)
                .then(resp => {
                    store.commit('updateWhitelistOneShotPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteWhitelistOneShot (id: number) {
        return new Promise((resolve) => {
            WhitelistOneShotServices.deleteWhitelistOneShot(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    downloadWhitelistOneShotFile () {
        return new Promise((resolve) => {
            WhitelistOneShotServices.getWhiteListOneShotFileById()
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
